export class ServiceItemModel{
    id: number;
    description :string;
    price :number;
    remark: string;
    isBold: boolean;
    creatorID: number;
    updatorID: number;
    createDate: Date;
    lastUpdate: Date;
    isDeleted: boolean;
    serviceTypeID: number;
    serviceType: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/service-item.model.ts